"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberCertifiedRequest = void 0;
var MemberCertifiedRequest = /** @class */ (function () {
    function MemberCertifiedRequest() {
    }
    return MemberCertifiedRequest;
}());
exports.MemberCertifiedRequest = MemberCertifiedRequest;
;
//# sourceMappingURL=memberCertified.request.js.map